/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (page, sortAttr, label, search) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${encodeURIComponent(label)}`;
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      ''
    )}`;
    return axios.get(requestURL);
  }

  getWallet(page, sortAttr = 'name', scope = 'mine') {
    let requestURL = `${this.url}/wallet?${buildContactParams(
      page,
      sortAttr,
      '',
      ''
    )}&scope=${scope}`;
    return axios.get(requestURL);
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getCompanies(contactId) {
    return axios.get(`${this.url}/${contactId}/companies`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  importUazapiGroupContacts(contactId, labels = []) {
    return axios.post(`${this.url}/${contactId}/import_uazapi_group_contacts`, {
      labels,
    });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search
    )}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }

  importContacts(payload) {
    const normalizedPayload = payload?.file ? payload : { file: payload };
    const formData = new FormData();
    formData.append('import_file', normalizedPayload.file);
    if (normalizedPayload.labels) {
      normalizedPayload.labels.forEach(label => {
        formData.append('labels[]', label);
      });
    }
    if (normalizedPayload.source) {
      formData.append('source', normalizedPayload.source);
    }
    if (normalizedPayload.schemaVersion) {
      formData.append('schema_version', normalizedPayload.schemaVersion);
    }
    if (normalizedPayload.defaultCountry) {
      formData.append('default_country', normalizedPayload.defaultCountry);
    }
    if (normalizedPayload.labelOperation) {
      formData.append('label_operation', normalizedPayload.labelOperation);
    }
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts(queryPayload) {
    return axios.post(`${this.url}/export`, queryPayload);
  }

  deleteContacts(file) {
    const url = `${this.url}/delete`;
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(url, formData);
  }

  deleteSelectedContacts(selection) {
    const url = `${this.url}/delete_selected`;
    const data = Array.isArray(selection)
      ? { contact_ids: selection }
      : selection;
    return axios.delete(url, { data });
  }

  bulkAssign(params) {
    return axios.post(`${this.url}/bulk_assign`, params);
  }

  bulkUpdate(params) {
    return axios.post(`${this.url}/bulk_update`, params);
  }
}

export default new ContactAPI();
